import { useAsyncValue, useLoaderData } from "react-router-dom";

import { VStack } from "@/components/layout";
import Loading from "@/components/layout/loading";
import Resolver from "@/components/resolver";
import { NotFoundError } from "@/modules/errors";
import Map, { LoadingMap } from "@/modules/map";

import LocationTable from "./location-table";

export default function ResolvedView() {
  const project = useAsyncValue();
  const { transactions, locations } = useLoaderData();

  if (!project.isLocationsEnabled) {
    throw new NotFoundError();
  }

  return (
    <VStack className="w-full">
      <VStack className="mt-10 w-full gap-4">
        <Resolver resolve={locations} fallback={<LoadingMap />}>
          {(locations) =>
            locations.length > 0 && (
              <>
                <h3 className="text-lg font-medium">Location data</h3>
                <Map locations={locations} />
              </>
            )
          }
        </Resolver>
      </VStack>
      <Resolver fallback={<Loading />} resolve={transactions}>
        <LocationTable />
      </Resolver>
    </VStack>
  );
}
